

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETALLKRAKPI= createAsyncThunk(
  "getAllKraKpi/getAllKraKpi",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllKraKpiSlice = createSlice({
  name: "getAllKraKpiSlice",
  initialState: {
    getAllKraKpi: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllKraKpi: (state) => {
        state.getAllKraKpi.loading = false
        state.getAllKraKpi.error = false
        state.getAllKraKpi.data = []
        state.getAllKraKpi.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLKRAKPI.fulfilled, (state, action) => {
      state.getAllKraKpi = {
        ...state.getAllKraKpi,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLKRAKPI.pending, (state, action) => {
      state.getAllKraKpi = {
        ...state.getAllKraKpi,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLKRAKPI.rejected, (state, action) => {
      state.getAllKraKpi = {
        ...state.getAllKraKpi,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllKraKpiAction = {
    GETALLKRAKPI,
};

export { getAllKraKpiAction };
export default getAllKraKpiSlice.reducer;
export const {setInitialStateOfgetAllKraKpi} = getAllKraKpiSlice.actions
